import { api, auth, common } from '@/service/http';
import router, { initialRoutes } from '@/router';
import { reactive } from 'vue';

export const state = reactive({
    appList: [],
});

export const getRoles = async args => {
    try {
        const { result, items } = await api('admin./role/list/get', args);
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '9aebd105-f1e7-4c21-bf58-6d8bada99062',
        };
    }
};

export const getRolesByApps = async () => {
    try {
        const response = await api('admin./role/list/all/get');
        return response.success ? response.items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3415b692-3a9a-49ef-ab74-ec00b6c441ca',
        };
    }
};

export const getRolesByAppsIds = async apps => {
    try {
        const response = await api('admin./role/list/by-apps/get', { apps });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '972d9b13-68b9-4804-8399-a9af4c6330a5',
        };
    }
};

export const getUsers = async () => {
    try {
        const { result, items } = await api('admin./user/list/get', {}, 10000);
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3f22a58b-4059-4712-b496-ec65dcb6b842',
        };
    }
};

export const getUser = async userId => {
    try {
        const { result, data } = await api('admin./user/get', { id: userId });
        return result ? data : {};
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4a7e3bdb-0e55-468c-bea1-584a321d7f32',
        };
    }
};

export const getUserByLogin = async () => {
    try {
        const { result, data } = await auth('admin./user/self/get');
        return result ? data : {};
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c9dec185-910d-467f-b7b5-7946029ad668',
        };
    }
};

export const archiveUsers = async userIds => {
    userIds = Array.isArray(userIds) ? userIds : [userIds];
    try {
        const response = await api('admin./user/store/put', { userIds: userIds });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'dfaa9e08-cce6-44d7-a2c5-d0f1efcb227f',
        };
    }
};

export const restoreUsers = async userIds => {
    userIds = Array.isArray(userIds) ? userIds : [userIds];
    try {
        const response = await api('admin./user/restore/put', { userIds: userIds });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '317e5f48-acf3-4702-b62f-8918041bd38e',
        };
    }
};

export const getLockReasons = async () => {
    try {
        const { result, items } = await auth('admin./user/lock/types/get');
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '93b09bf3-cea6-4fc9-9897-a076bf3d0561',
        };
    }
};

export const getLocks = async (user_id = null, not_expired = false, lock_type_id = null, reason = null) => {
    try {
        const response = await api('admin./user/lock/get', { user_id, not_expired, lock_type_id, reason });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '88b2bf9d-ca34-40b5-bf8d-3040140af12d',
        };
    }
};

export const lockUser = async (deleted_locks, locks) => {
    try {
        const response = await api('admin./user/lock/set', { deleted_locks, locks });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '170dfe42-d599-4b5e-b044-0b0d1f33d4fb',
        };
    }
};

export const lockUsers = async (user_ids, lock_type_id, dt_beg, dt_end = null, reason = null) => {
    try {
        const response = await api('admin./user/lock/add', { user_ids, lock_type_id, dt_beg, dt_end, reason });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5ceecdd8-bc47-4de7-bd16-8e3edc858f8e',
        };
    }
};

export const blockUsers = async (userIds, from, to, lock_reason) => {
    try {
        if (!Array.isArray(userIds)) {
            userIds = [userIds];
        }
        const response = await api('admin./user/lock/put', {
            userIds: userIds,
            date: { from, to },
            lock_reason: lock_reason,
        });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'dd9e6c46-81c0-4fb1-a4d6-c4bdf4cd151e',
        };
    }
};

export const unlockUsers = async (userIds, from, to, lock_reason) => {
    try {
        if (!Array.isArray(userIds)) {
            userIds = [userIds];
        }
        const response = await api('admin./user/unlock/put', {
            userIds: userIds,
            date: { from, to },
            lock_reason: lock_reason,
        });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '417dbe4b-06df-4448-aeb3-1e0df4b849e6',
        };
    }
};

export const deleteUsers = async userIds => {
    userIds = Array.isArray(userIds) ? userIds : [userIds];
    try {
        const response = await api('admin./user/del/put', { userIds });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '8da6494b-0e12-4353-a963-502245995ef9',
        };
    }
};

export const getAreas = async () => {
    try {
        const { result, items } = await api('admin./area/list/get', {});
        return result ? items?.filter(item => item.id !== 127) : []; // убирает область "Общедоступные формы"
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3f17a7c5-43d2-4afd-a059-33edbdc82d16',
        };
    }
};

export const getGroups = async () => {
    try {
        const { result, items } = await api('admin./group-area/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'fb4a18bf-d37f-4558-a396-b7adbd066a96',
        };
    }
};

export const getAreasByAppKod = async (kod_app, for_departs) => {
    try {
        const { result, items } = await api('admin./app/group-area/list/get', { kod_app, for_departs });
        return result ? items : {};
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'da562b1a-50aa-4e0a-9f85-7d47f406e4ba',
        };
    }
};

export const getAreasWithApps = async () => {
    try {
        const { result, items } = await api('admin./app/area/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'd8ec6f91-5a10-481f-a562-d642aea100a3',
        };
    }
};

export const getRoleById = async args => {
    try {
        const { result, items } = await api('admin./role/get', { app: args.appId, id: args.roleId });
        return result ? items[0] : {};
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'b62cab6d-1589-4b4c-9afe-8e31da563b8b',
        };
    }
};

export const getOfficialUserData = async userId => {
    try {
        const { result, data } = await auth('admin./official/get', { id: userId });
        return result ? data : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'bf22ef44-f806-4618-b6f3-eda3f1302eb4',
        };
    }
};

export const getUserDeparts = async () => {
    try {
        const { result, items } = await auth('admin./department/start-list/get');
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '79627c43-4a4a-4a10-b9c6-b3772d833230',
        };
    }
};

export const getDepartments = async () => {
    try {
        const { result, items } = await api('admin./department/list/get');
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'a534e07d-158d-4ac6-b26a-6404e879777f',
        };
    }
};

export const getDepartmentsWithGroupId = async group_id => {
    try {
        const { result, items } = await api('admin./group-area/department/list/get', { group_id });
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'f09ead74-d969-4d9d-9741-3b08dbb57d53',
        };
    }
};

export const getDepartmentsWithOfficials = async kod_ecls => {
    try {
        const { result, items } = await api('admin./department/official/list/get', { kod_ecls });
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '851dbe90-e2c0-4544-a48f-1ebb74ea7fb4',
        };
    }
};

export const validateCodeRole = async code => {
    try {
        const { success } = await api('admin./role/validate', { code: code });
        return success;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '58b0482f-b25c-4ab4-93e5-aa1af3b9b53e',
        };
    }
};

export const updateUserData = async requestBody => {
    try {
        const response = await api('admin./user/update', requestBody);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'a23b4497-eaf2-4e94-bba0-857c61afcdd0',
        };
    }
};

export const createUser = async requestBody => {
    try {
        const response = await api('admin./user/create', requestBody);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c4485da1-f572-4e6c-b8b8-744dda31d837',
        };
    }
};

export const checkRoleDependencies = async roleIds => {
    try {
        const { result, items } = await api('admin./role/dependence/list/get', roleIds);
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '8fbcecd1-4eba-4866-8e90-a0c3bf71f5d3',
        };
    }
};

export const deleteRoles = async roleIds => {
    roleIds = Array.isArray(roleIds) ? roleIds : [roleIds];
    try {
        const response = await api('admin./role/delete/put', { roleids: roleIds });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c0ba2159-d503-47ea-ad79-9fe74090eeff',
        };
    }
};

export const createRoles = async requestBody => {
    try {
        const response = await api('admin./role/create', requestBody);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '7662139d-b848-492b-994b-202db5f4bd86',
        };
    }
};

export const updateRoleData = async requestBody => {
    try {
        const response = await api('admin./role/update', requestBody);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'e0a359b9-92c5-45e7-b923-c8dfbad5fa60',
        };
    }
};

export const getUserRights = async userId => {
    try {
        const response = await auth('admin./user/right/get', { userId: userId });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '31e21a33-f8dd-45b5-b6e9-bfa8d1a08f4a',
        };
    }
};

export const getUserTypes = async () => {
    try {
        const response = await api('admin./user/types/get');
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '2325c8a3-ffe1-428c-9b40-e38724e4c168',
        };
    }
};

export const getRouteListValidate = async () => {
    try {
        const intialRoutesNames = initialRoutes.map(route => route.name);
        const routes = router.getRoutes().filter(el => !intialRoutesNames.includes(el.name));
        const paths = routes.map(route => route.path);
        const response = await auth('admin./register/route/list/validate', { routes: paths });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '02be906d-a420-410f-910b-097a5ce7bba6',
        };
    }
};

export const getRouteListChildren = async ui_route_id => {
    try {
        const response = await api('admin./right/children/list/get', { ui_route_id });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '470469a7-3a2a-4baa-b3a4-22535560258e',
        };
    }
};

export const getPasswordValidateRules = async user_type_id => {
    try {
        const response = await auth('admin./user/types/texts/get', { user_type_id });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3379d21f-1585-4fd7-b733-e2a0d9eefa24',
        };
    }
};

export const checkPasswordValidate = async (user_type_id, password) => {
    try {
        const response = await auth('admin./user/password/validate', { user_type_id, password });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '7b64fd17-b0d3-4aed-b2c2-16b0dcd459d7',
        };
    }
};

export const putNewPassword = async (id, password, new_password) => {
    try {
        const response = await auth('admin./user/password/put', { id, password, new_password });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'a1e18a4e-8289-430a-83fc-c225c6cd55c0',
        };
    }
};

export const getGeneratedPassword = async user_type_id => {
    try {
        const response = await auth('admin./user/password/generate', { user_type_id });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'bf079d61-1fc0-4130-aed1-b7982c8bd951',
        };
    }
};

export const getGeneratedPasswordCommon = async user_type_id => {
    try {
        const response = await common('admin./user/password/generate', { user_type_id });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'b835b5f2-c33a-4066-b78e-0f36b59d66c1',
        };
    }
};

export const getPasswordValidateRulesCommon = async user_type_id => {
    try {
        const response = await common('admin./user/types/texts/get', { user_type_id });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3379d21f-1585-4fd7-b733-e2a0d9eefa24',
        };
    }
};

export const getRestoreLinkCommon = async (user_login, origin_url) => {
    try {
        const response = await common('admin./access/restore-link/get', { user_login, origin_url });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'd84080bd-7052-4042-809a-3f590e94b74b',
        };
    }
};

export const checkRestoreLinkCommon = async link => {
    try {
        const response = await common('admin./access/restore-link/check', { link });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'ae8e00fb-a005-49d9-9f58-89e98546e996',
        };
    }
};

export const putPasswordRestoreLinkCommon = async (link, new_password) => {
    try {
        const response = await common('admin./access/restore-link/password/put', { link, new_password });
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4c8e859a-3fdd-461b-b236-b2208c0528fb',
        };
    }
};
